<template>
  <v-tabs v-model="active">
    <v-tab
      v-for="(tab, index) in tabs"
      :key="index"
      @click="tabSelected(tab.id)"
    >
      <v-icon :color="tab.color" class="mr-2" medium>{{ tab.icon }}</v-icon>
      {{ tab.label }} ({{ project.counts[tab.id] | number }})
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import store from "@/store/";
export default {
  data() {
    return {
      active: null,
      tabs: [
        {
          id: "approved",
          label: "Approved",
          icon: "mdi-thumb-up",
          color: "green darken-2",
        },
        {
          id: "myNew",
          label: "My New",
          icon: "mdi-account",
          color: "gray",
        },

        {
          id: "allNew",
          label: "All New",
          icon: "mdi-account-group",
          color: "gray",
        },
      ],
    };
  },
  filters: {
    number: function(value) {
      if (value !== 0 && !value) return "";
      return value.toLocaleString();
    },
  },
  mounted() {
    let subsection = this.$route.path
      .split("/")
      .slice(-1)
      .pop();

    this.active = this.tabs
      .map(function(e) {
        return e.id;
      })
      .indexOf(subsection);
    // this.active = this.tabs.indexOf(this.state.)
  },
  computed: {
    ...mapState(["project"]),
    ...mapGetters({
      userAdminStatus: "user/userAdminStatus",
      userAdminId: "user/userAdminId",
    }),
  },
  methods: {
    tabSelected(status) {
      let current_status = this.$route.params.status;
      let id = this.$route.params.id;
      let user = this.userAdminId;
      if (status != current_status) {
        if (this.userAdminStatus) {
          store.dispatch("project/setCurrentUrl", {
            status: status,
            project_id: id,
          });
          this.$router.push({ path: `/project/a/${user}/${id}/${status}` });
        } else {
          store.dispatch("project/setCurrentUrl", {
            status: status,
            project_id: id,
          });
          this.$router.push({ path: `/project/${user}/${id}/${status}` });
        }
      }
    },
  },
};
</script>

<style></style>
